import React, { FC } from 'react';
import styles from './BoxHolder.module.scss';

type BoxHolderHeaderProps = {
    children?: React.ReactNode;
    imageUrl?: string;
    content?: Array<string>;
}

const BoxHolderHeader: FC<BoxHolderHeaderProps> = ({ children, imageUrl, content }) => {
    return (
        <div className={`${styles.boxHolder} ${styles['boxHolder--header']}`}>
            <div className={`${styles.boxHolder__header}`}>
                <div className={`${styles.boxHolder__headerContent}`}>
                    {content?.map((item, index) => {
                        if (!item) {
                            return null;
                        }
                        return <div className={`${styles.boxHolder__headerItem} ${index === 0 ? styles[`boxHolder__headerItem--bold`] : ''}`} key={index}>{item}</div>
                    })}
                </div>
                {children}
                {imageUrl && <div className={`${styles.boxHolder__headerImg}`}>
                    <img src={imageUrl} />
                </div>}
            </div>

        </div>
    )
}

export default BoxHolderHeader;